import { DataBean } from "../DataBean";

export class AdquisitionContractByAdquisition extends DataBean {



    public async getAdquisitionContractByProject(idProject: any, state: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getAdquisitionContractByProject_Number_Number_Number_Number", [idProject, state, page, recordsPerPage]);
    }

}